export const THREAD_RUN_SELECT = [
  // used for rendering run tree
  'trace_id',
  'id',
  'name',
  'run_type',
  'total_tokens',
  'prompt_tokens',
  'completion_tokens',
  'total_cost',
  'prompt_cost',
  'completion_cost',

  // used for run preview
  'inputs_preview',
  'outputs_preview',
  'inputs_s3_urls',
  'outputs_s3_urls',
  's3_urls',
];
